var map = {
	"./banhanguytin/3.png": "e919",
	"./chuyencan/3.png": "4968",
	"./daigiadataha/3.png": "9946",
	"./duhanhgia/3.png": "500b",
	"./thanhsanma/3.png": "f5b1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b7fe";